<template>
    <div class="mw-500 mx-auto my-ml" v-if="isGrant === 0">
        <h2 class="fw-bold text-center">
            Claim your <span class="ticket-small">$500</span><br> learning grant
        </h2>
        <div class="text-center mt-md mb-ml">
            We'll instantly add $500 in learning credits to your account so you can start exploring right away.
        </div>
        <div class="text-center mt-md mb-ml" v-if="success_message.length">{{ success_message }} </div>
        <form @submit.prevent="submitForm" class="mw-360 mx-auto">
            <button
                :class="[
                    'w-100',
                    'btn',
                    'btn--primary',
                    'btn--large',
                    'btn--full',
                    'btn--loader',
                ]"
                :disabled="isLoading"
                @click="submitForm"
            >YES, ADD MY $500</button>
            <div class="caption mt-sm text-dark-gray">
                <i class="icon-lock"></i> By proceeding, you agree to our
                <a :href="`https://${domain}/terms-and-conditions`" target="_blank">Terms of Service</a> and
                <a :href="`https://${domain}/privacy-policy`" target="_blank">Privacy Policy</a>.
            </div>
        </form>
    </div>
    <div  class="mw-500 mx-auto my-ml text-center" v-else-if="isGrant === 1">
        <h2 class="fw-bold">
            You've already activated your <span class="ticket-small">$500</span> grant!
        </h2>
        <div class="mt-md mb-ml">
            You've already activated your <strong>$500 grant</strong>! We offer one grant per person.
            Click below to begin shopping or manage your account.
        </div>
        <a :href="`https://${domain}/category/make-money-with-ai`"
            :class="[
                'mw-400',
                'btn',
                'btn--primary',
                'btn--large',
                'btn--full',
                'btn--loader',
            ]"
        >Start shopping</a>
        <div class="mt-md">
            <a :href="`https://${domain}/profile`" class="text-yellow fw-bold">My account</a>
        </div>
    </div>
    <div  class="mw-500 mx-auto my-ml text-center" v-else-if="isGrant === 2">
        <h3 class="fw-bold">
            Congratulations!
        </h3>
        <h2 class="fw-bold mt-sm">
            Your <span class="ticket-small">$500</span> grant is ready!
        </h2>
        <div class="mt-md mb-ml">
            Your {{ domain }} account is live, and <strong>your balance now includes $500</strong> to spend on
            any course, guide, or checklist.
        </div>
        <a :href="`https://${domain}/category/make-money-with-ai`"
            :class="[
                'mw-400',
                'btn',
                'btn--primary',
                'btn--large',
                'btn--full',
                'btn--loader',
            ]"
        >Start shopping</a>
        <div class="mt-md">
            <a :href="`https://${domain}/profile`" class="text-yellow fw-bold">My account</a>
        </div>
    </div>
</template>

<script>

import { defineComponent } from 'vue'
import CustomSelect from "@/BinaryFlow/components/Common/CustomSelect.vue";
export default defineComponent({
    name: "grant",
    components: {CustomSelect},
    data() {
        return {
            isOpen: false, // до инициализации
            isLoading: false, // защита от множественных запросов
            user: {
                email: '',
                phone_number: '',
                code: 'US'
            },

            isEmailValid: false,
            isGrant: -1, // -1 - загрузка, 0 - грант ещё не выдали, 1 - грант уже выдали, 2 - поздравляем с грантом
            codes: [],
            activeMask: '(###) ###-####',
            masks: {},
            error_message: '',
            success_message: '',
        }
    },
    mounted() {
        this.init();
    },
    computed: {
        domain() {
            return window.location.hostname.replace('www', '')
        },
        emailClasses() {
            return {
                'filled': this.isEmailValid && this.user.email,
                'error': !this.isEmailValid && this.user.email,
                'empty': ! this.isEmailValid && this.user.email.length === 0,
            };
        }
    },
    methods : {
        /**
         * Проверяем есть ли аккаунт у клиента
         * @returns {Promise<void>}
         */
        async init() {
            try {
                const response = await this.$http.post('/account/hasGrant', {}, { timeout: 5000 })

                // Проверка структуры ответа
                if( ! response?.data ) {
                    this.error_message = 'Invalid response';
                    return;
                }

                const { status, data } = response?.data ?? {};
                if( status !== 'success' ) {
                    this.error_message = data?.message ?? 'Unknown error from server';
                    return;
                }

                const grant = !!data?.grant ? 1 : 0

                // грант ещё не выдан
                if( grant === 0 ) {
                    // есть ли параметры в ссылке?
                    const params  = new URLSearchParams( window.location.search );
                    const n = params.get('n');
                    if( n ) {
                        // сразу отправляем запрос на получение гранта
                        await this.submitForm()
                        // ждём ответа и показываем this.isGrant === 0 и сообщение (если успешно всё)
                    } else {
                        // показываем кнопку с формой
                        this.isGrant = 0
                    }
                } else {
                    this.isGrant = 1
                }
            } catch (err) {
                console.log('Request cancelled:', err.message);
            } finally {
                this.isOpen = true
            }
        },

        /**
         * Отправка формы
         */
        async submitForm() {

            if( this.isLoading )
                return;

            this.isLoading = true

            try {
                const response = await this.$http.post('/account/grant', {}, { timeout: 5000 })

                // Проверка структуры ответа
                if( ! response || ! response.data ) {
                    console.log('Invalid response');
                }

                const { status, data } = response.data;
                if( status === 'error' || !['success', 'error'].includes( status ) ) {
                    console.log( data.message || 'Unknown error from server' );
                }

                if( 'status' in data ) {
                    this.isGrant = data.status === true ? 1 : 0;
                    this.error_message = '';

                    if( data.status === false ) {
                        this.success_message = data.message || 'Balance replenished';
                        this.isGrant = 2;
                    } else {
                        this.success_message = data.message || 'You have received a grant before';
                    }
                }

            } catch (err) {
                console.log('Request cancelled:', err.message);
            } finally {
                this.isLoading = false
            }
        },
    }
})

</script>

<style scoped>

</style>